import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'

import { REACT_APP_API_PRINCIPAL_URL } from '../configs/settings/environment'

/**
 * Gets the list of countries.
 */
export const getCountries = factoryService(() => getJsonRequest(`${REACT_APP_API_PRINCIPAL_URL}/v1/geografia/pais`))
